$(function () {
	malleysCustomCart.datepicker.init();
	malleysCustomCart.textareaMaxLength();
});

const malleysCustomCart = {
	datepicker: {
		disabledDaysOfWeek: [0, 6],
		disabledDays: ["11-24-2022", "12-23-2022", "12-26-2022", "12-28-2022", "12-29-2022", "12-30-2022", "1-2-2023", "4-27-2023", "4-28-2023"],
		today: moment(),
		maxDays: 120,
		cutoffHour: 12,

		init() {
			const elem = document.querySelector("#ship-date");
			const setValue = elem.dataset.value;
			const setDate = moment(setValue);

			// Set the firstDayAllowed based on the cutoffHour
			let firstDayAllowed = this.today.format("H") >= this.cutoffHour ? moment().add(1, "day") : moment();

			while (!this.isValidDate(firstDayAllowed)) {
				firstDayAllowed.add(1, "days");
			}

			let datepickerOptions = {
				pickLevel: 0,
				daysOfWeekDisabled: this.disabledDaysOfWeek,
				minDate: firstDayAllowed.toDate(),
				maxDate: this.today.add(this.maxDays, "day").toDate(),
				defaultViewDate: firstDayAllowed.toDate(),
				autohide: true,
				datesDisabled: this.disabledDays,
			};

			// console.log(datepickerOptions);

			let datapicker = new Datepicker(elem, datepickerOptions);

			if (setDate.isAfter(firstDayAllowed)) {
				datapicker.setDate(setDate.toDate());
			} else {
				datapicker.setDate(firstDayAllowed.toDate());
			}
		},

		isValidDate(date) {
			if (this.disabledDays.indexOf(date.format("M-D-YYYY")) >= 0) return false;
			if (this.disabledDaysOfWeek.indexOf(date.day()) >= 0) return false;
			return true;
		},
	},

	textareaMaxLength() {
		const giftNoteTextarea = document.getElementById("note");
		const maxLength = parseInt(giftNoteTextarea.getAttribute("maxlength"));

		const warningThreshold = Math.ceil(maxLength * 0.5);
		const errorThreshold = Math.ceil(maxLength * 0.9);

		let counterLabel = document.createElement("div");
		counterLabel.className = "character-counter";

		let charactersCurrentCount = document.createElement("span");
		charactersCurrentCount.className = "character-counter__remaining";
		charactersCurrentCount.textContent = 0;

		let charactersMaxLength = document.createElement("span");
		charactersMaxLength.className = "character-counter__maxlength";
		charactersMaxLength.textContent = maxLength;

		counterLabel.append(charactersCurrentCount, charactersMaxLength);

		giftNoteTextarea.after(counterLabel);

		giftNoteTextarea.addEventListener("input", ({ currentTarget: target }) => {
			const maxLength = parseInt(target.getAttribute("maxlength"));
			const currentLength = target.value.length;

			if (currentLength >= errorThreshold) {
				counterLabel.classList.add("character-counter--error");
			} else {
				counterLabel.classList.remove("character-counter--error");
			}

			if (currentLength >= warningThreshold) {
				counterLabel.classList.add("character-counter--warning");
			} else {
				counterLabel.classList.remove("character-counter--warning");
			}

			if (currentLength >= 1) {
				counterLabel.classList.add("character-counter--good");
			} else {
				counterLabel.classList.remove("character-counter--good");
			}

			charactersCurrentCount.textContent = currentLength;
		});
	},
};
